import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserProfileState } from "./LoginAction";

const initialState: UserProfileState = {
  profileKeys: {
    grade: null,
    first_name: null,
    last_name: null,
    education: null,
    admission_year: null,
    institute_name: null,
    roll_number: null,
    course: null,
    program: null,
    status: null, // Static title
    department: null,
    partner_institute: null,
    institute_id: null,
    email_address: null,
    corporate_name: null,
    industry: null,
    no_of_employees: null,
    contact_email: null,
    contact_phone: null,
    registered_office_address: null,
    head_office_address: null,
    country: null,
    state: null,
    city: null,
    zip_code: null,
    logo_url: null,
    favicon_url: null,
    candidate_id: null, //To As Param in firebase
  },
  courses: {
    program: [], // Initialize as empty
    department: [], // Initialize as empty
  },
  loading: false,
  error: null,
  livesessionurl: null,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setProfileKeys(state, action) {
      state.profileKeys = action.payload;
    },
    setLiveSessionActiveUrl(state, action: PayloadAction<string | null>) {
      state.livesessionurl = action.payload;
    },
    setCourses(
      state,
      action: PayloadAction<{ program: string[]; department: string[] }>
    ) {
      state.courses = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    updateProfile(
      state,
      action: PayloadAction<Partial<UserProfileState["profileKeys"]>>
    ) {
      state.profileKeys = { ...state.profileKeys, ...action.payload };
    },
    clearProfileKeys(state) {
      state.profileKeys = initialState.profileKeys;
    },
  },
});

export const {
  setProfileKeys,
  setCourses,
  setLoading,
  setError,
  updateProfile,
  clearProfileKeys,
  setLiveSessionActiveUrl,
} = userProfileSlice.actions;

export default userProfileSlice.reducer;
